import { Reducer } from 'redux';
import { InitialReasonRefusal, ReasonRefusal } from './types';

const INITIAL_STATE: InitialReasonRefusal = {
  page: 1,
  totalRecords: 0,
  rows: [
    {
      reasonRefusalId: '',
      reason: '',
      description: '',
      createdAt: '',
      updatedAt: '',
    },
  ],
  description: '',
  reason: '',
};

const reducer: Reducer<InitialReasonRefusal> = (
  state = INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    case ReasonRefusal.GET_REASONS_REFUSAL: {
      return { ...state, ...action.payload };
    }

    case ReasonRefusal.SET_REASON_REFUSAL: {
      return { ...state, ...action.payload };
    }

    default:
      return state;
  }
};

export default reducer;
